import React, { useState, useEffect, useRef } from 'react';
import { useQuery, useSubscription } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import Token from '../Token';
import { Grid, Link, Paper, Typography, Zoom } from '@material-ui/core';
import { utils } from 'ethers';
import moment from 'moment';

const QUERY = gql`
    {
        reserves(
          orderBy: id,
          orderDirection: asc,
          where:{
            isRemoved: false,
            isTradeEnabled:true
          }
        ) {
        id
        isPermissionless
        network {id}
        tokenBalances {
            id
            amount
            token {
            id
            }
        }
        }
    }
`;

const SUBSCRIPTION = gql`
    subscription {
        reserves(
          orderBy: id,
          orderDirection: asc,
          where:{
            isRemoved: false,
            isTradeEnabled:true
          }
        ) {
          id
          isPermissionless
          network {id}
          tokenBalances {
            amount
            token {
              id
            }
          }
        }
    }
`;

function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

function sliceAddress(address) {
    return `${address.slice(0,6)}...${address.slice(-4)}`
}

function convertWei(tokenAddress, amount, fractionDigits=4) {
    const decimals = 18
    const wei = utils.bigNumberify(amount)
    // TODO - get actual decimals for tokenAddress
    return parseFloat(utils.formatUnits(wei, decimals)).toLocaleString([], ({minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits}))
}

const MomentTimeAgo = ({ id, timestamp }) => {
    const momentObject = moment(parseInt(timestamp) * 1000)
    const [fromNow, setFromNow] = useState(momentObject.fromNow())

    useInterval(() => {
        setFromNow(momentObject.fromNow())
    }, 1000)

    return fromNow
}

const ReservesHeader = ({ loading }) => {
    return (
        <React.Fragment>
            <Typography variant="h6">Reserves</Typography>
            <Typography variant="body2" gutterBottom>{loading ? "Connecting..." : "Connected"}</Typography>
        </React.Fragment>
    )
}

const ReservesContent = ({ data }) => {

    if (!data) return null
  
    return data.reserves.map(({ id, network, tokenBalances }) => 
        tokenBalances 
        && tokenBalances.length > 0 
        && (
            <Zoom in={true} key={id}>
                <Paper elevation={2} style={{ marginBottom: 18, padding: 8 }}>
                    <Grid container direction="column" justify="flex-start" alignItems="stretch">
                        <Grid item>
                            <Typography variant="caption">
                                <Link to={`https://etherscan.io/contract/${id}`}>{ id }</Link>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="caption">
                                { network ? network.id : "Network not found" }
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row">
                        { tokenBalances.map((balance) =>
                            (
                                <Grid item key={`${id}-${balance.token.id}`} xs={ tokenBalances.length > 2 ? 4 : 6 }>
                                    <Typography variant="body1">
                                        { convertWei(balance.token.id, balance.amount, 0) }
                                        {' '}
                                        <Token address={balance.token.id} size={18} />
                                    </Typography>
                                </Grid>
                            )
                        )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Zoom>
        )
    );
  }

  const Reserves = () => {
    /* 
    //  HTTP and WebSocket
    //    - for http: useQuery
    //    - for ws: useSubscription
    */

    // const { loading, error, data } = useQuery(QUERY);
    const { loading, error, data } = useSubscription(SUBSCRIPTION);

    if (error) console.log(error)

    console.log(data)

    return (
        <React.Fragment>
            <ReservesHeader loading={loading} />
            <ReservesContent data={data} />
        </React.Fragment>
    )
  }

export default Reserves